import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class PhoneConsultationStore extends LocalModel {
    constructor() {
        super('phoneConsultation', {
            namePlural: 'phoneConsultations',
            namePluralReal: 'phoneconsultations',
            sort: '-date -createdDate',
            limit: 50,
            api: {
                search: {
                    url: '/api/phoneconsultations/',
                    params: {
                        limit: 50,
                        sort: '-date -createdDate',
                    },
                },
                load: {
                    url: '/api/phoneconsultations/',
                    params: {},
                },
                save: {
                    url: '/api/phoneconsultations/',
                    params: {},
                },
                delete: {
                    url: '/api/phoneconsultations/',
                    params: {},
                },
            },
        });
    }

    @observable phoneConsultation = {};

    @observable phoneConsultations = [];

    @observable animalPhoneConsultations = [];

    @observable newPhoneConsultation = {};

    @action
    async loadForAnimal(animalId) {
        const response = await util.fetchApi('/api/phoneconsultations/', { method: 'GET' }, { animal: animalId, limit: 200 });
        const list = Array.isArray(response?.data) ? response.data : [];
        this.updateKeyValue('animalPhoneConsultations', list);
        return list;
    }

    @action
    async escalateToSale(id) {
        const response = await util.fetchApi(`/api/phoneconsultations/${id}/escalate-to-sale`, { method: 'POST' }, {});
        return response?.data;
    }

    @action
    async escalateToJournal(id) {
        const response = await util.fetchApi(`/api/phoneconsultations/${id}/escalate-to-journal`, { method: 'POST' }, {});
        return response?.data;
    }
}

const phoneConsultationStore = new PhoneConsultationStore();
export default phoneConsultationStore;
